module.exports = __webpack_public_path__ + "img/banner.9c950519.png";